import { render } from "./IconTakePhoto.vue?vue&type=template&id=742d96df"
import script from "./IconTakePhoto.vue?vue&type=script&lang=ts"
export * from "./IconTakePhoto.vue?vue&type=script&lang=ts"
script.render = render

export default script